import { useEffect, useState } from 'react';
import type { PackageTimeEntry } from '@/types';

const formatSecondsAsClock = (seconds: number) => {
  const totalSeconds = Math.max(0, seconds);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const remainingSeconds = totalSeconds % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

const getElapsedSeconds = (entry: PackageTimeEntry) => {
  let totalSeconds = entry.accumulatedSeconds;

  if (entry.status === 'running') {
    const startTime =
      typeof entry.startTime === 'string'
        ? new Date(entry.startTime).getTime()
        : entry.startTime.getTime();

    totalSeconds += Math.floor((Date.now() - startTime) / 1000);
  }

  return Math.max(0, totalSeconds);
};

export const usePackageTimeEntryDisplay = (entry?: PackageTimeEntry | null) => {
  const [displayTime, setDisplayTime] = useState('00:00:00');

  useEffect(() => {
    if (!entry) {
      setDisplayTime('00:00:00');
      return;
    }

    const updateDisplayTime = () => {
      setDisplayTime(formatSecondsAsClock(getElapsedSeconds(entry)));
    };

    updateDisplayTime();

    if (entry.status !== 'running') {
      return;
    }

    const interval = window.setInterval(updateDisplayTime, 1000);
    return () => window.clearInterval(interval);
  }, [entry]);

  return displayTime;
};
